import React from 'react'
import { useState, useEffect, useRef } from "react";
import "./Gallery.css";
import img3 from "../../assets/images/3.webp";
import img4 from "../../assets/images/4.webp";
// import img5 from "../../assets/images/6.webp";
import img6 from "../../assets/images/7.webp";
import img7 from "../../assets/images/8.webp";
import img8 from "../../assets/images/9.webp";
import img9 from "../../assets/images/12.webp";
import img10 from "../../assets/images/13.webp";
import img11 from "../../assets/images/14.webp";
import img12 from "../../assets/images/15.webp";
import img13 from "../../assets/images/16.webp";

const ITEMS = [
  { img: img3 },
  { img: img4 },
  // { img: img5 },
  { img: img6 },
  // { img: img7 },
  { img: img8 },
  // { img: img9 },
  { img: img10 },
  { img: img11 },
  // { img: img12 },
  { img: img13 },
];

const ITEM_WIDTH = 238;
const GAP = 16;

function getCloneCount(width) {
  if (width <= 1920) return 2;
  if (width <= 2560) return 3;
  if (width <= 3840) return 4;
  return 8;
}

function ItemCard({ img, text }) {
  return (
    <div className="item-wrap">
      <img src={img} alt={text} loading="lazy" />
    </div>
  );
}


function Gallery() {
     const [cloneCount, setCloneCount] = useState(() => getCloneCount(window.innerWidth));

  useEffect(() => {
    let timeout;
    const handleResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setCloneCount(getCloneCount(window.innerWidth));
      }, 300);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeout);
    };
  }, []);

  const totalSets = cloneCount + 1;
  const contentWidth = (ITEM_WIDTH + GAP) * ITEMS.length * totalSets;

  return (
    <>
     <div className="scroll-container">
      <div className="scroll-wrapper">
        <div className="scroll-content" style={{ width: `${contentWidth}px` }}>
          {Array.from({ length: totalSets }).flatMap((_, i) =>
            ITEMS.map((item, j) => (
              <ItemCard key={`${i}-${j}`} img={item.img} text={item.text} />
            ))
          )}
        </div>
      </div>
    </div>
    </>
  )
}

export default Gallery